class ProductStickyAtc extends HTMLElement {

  constructor() {
    super();

    this.elements = {
      button: this.querySelector('[data-product-sticky-atc-el="button"]'),
      text: this.querySelector('[data-product-sticky-atc-el="text"]'),
      scrollToElement: document.querySelector('[data-product-sticky-atc-external-el="scrollToElement"]'),
    };

    this.observer = null;
  }

  connectedCallback() {
    this.setupEventListeners();
    this.createIntersectionObserver();
  }

  setupEventListeners() {
    this.elements.button.addEventListener('click', this.handleButtonClick.bind(this));
    document.addEventListener('variant:changed', this.handleButtonTranslation.bind(this));
  }

  handleButtonClick() {
    this.elements.scrollToElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
    this.elements.scrollToElement.click();
  }

  handleButtonTranslation(event) {
    const available = event.detail.available;

    if (available) {
      this.elements.text.textContent = this.elements.text.dataset.inStockTranslation;
    } else {
      this.elements.text.textContent = this.elements.text.dataset.outOfStockTranslation;
    }
  }

  createIntersectionObserver() {
    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.boundingClientRect.top < 0 && entry.isIntersecting === false) {
          this.setAttribute('aria-hidden', false);
        } else {
          this.setAttribute('aria-hidden', true);
        }
      });
    };

    this.observer = new IntersectionObserver(callback, { threshold: 0.1 });

    this.observer.observe(this.elements.scrollToElement);
  }
}

customElements.define('product-sticky-atc', ProductStickyAtc);
